import { render, staticRenderFns } from "./BarDifference.vue?vue&type=template&id=32ddda80&scoped=true&"
import script from "./BarDifference.vue?vue&type=script&lang=ts&"
export * from "./BarDifference.vue?vue&type=script&lang=ts&"
import style0 from "./BarDifference.vue?vue&type=style&index=0&id=32ddda80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ddda80",
  null
  
)

export default component.exports